import { Card, Col, Modal, Row, Form } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Pagination from 'components/tabel/Pagination';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Table, Tooltip } from 'antd';

/**
 * این کامپوننت برای نمایش مدال پیگیری در جدول سفارشات است
 */
const ModalOrderTracking = ({
  showitem,
  handleCloseMoudal,
  id,
  isContractual = false,
}) => {
  const { urldashboard, authentication } = useContext(DashboardContext);

  const [dataFetch, setDataFetch] = useState({});
  const [loading, setLoading] = useState(false);

  const [startPage, setStartPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handelDetafech = async (startPage, pageSize) => {
    const command = {
      page: parseInt(startPage),
      pageSize: parseInt(pageSize),
      orderSchduleId: id,
    };

    setLoading(true);

    try {
      const res = await Axios.post(
        `${urldashboard}/order/getOrderTracking`,
        JSON.stringify(command),
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );

      const data = await res.data;
      setDataFetch(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.message === 'Network Error') {
        handleCloseMoudal();
        toaster.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید');
      } else {
        setLoading(false);
        handleCloseMoudal();
        toaster.error(error?.response?.data?.message);
      }
    }
  };

  //#Pagination

  useEffect(() => {
    handelDetafech(startPage, pageSize);
  }, [startPage, pageSize]);

  const handlePageNumber = (number) => {
    setStartPage(number);
  };

  const handlePrevPage = () => {
    if (parseInt(dataFetch.page) === 1) {
    } else {
      setStartPage(startPage - 1);
    }
  };

  const handleNextPage = () => {
    if (dataFetch.page === dataFetch.totalPage) {
    } else {
      setStartPage(startPage + 1);
    }
  };

  const arrayOfPageSizes = [10, 20, 50, 100, 500, 1000, 2000];
  const handleRow = (e) => {
    setPageSize(parseInt(e.target.value));
    setStartPage(1);
  };

  const columns = [
    {
      title: 'سامانه',
      dataIndex: 'isPRMAction',
      key: 'isPRMAction',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? 'PRM' : 'CRM'}</span>,
    },
    {
      title: 'ثبت‌کننده',
      dataIndex: 'creatorName',
      key: 'creatorName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ ثبت',
      dataIndex: 'persianCreateDate',
      key: 'persianCreateDate',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'عنوان',
      dataIndex: 'title',
      key: 'title',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'دلیل پیگیری',
      dataIndex: 'contractualOrderOperationReasonTitle',
      key: 'contractualOrderOperationReasonTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'توضیحات',
      dataIndex: 'description',
      key: 'description',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
  ];

  return (
    <Modal show={showitem} onHide={handleCloseMoudal} size={'lg'}>
      <Modal.Header>
        <Modal.Title>پیگیری کارهای انجام شده</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={handleCloseMoudal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body>
        {isContractual ? (
          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={dataFetch?.data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />
        ) : (
          <Row>
            {dataFetch?.data?.length > 0
              ? dataFetch?.data?.map((item) => (
                  <Col
                    lg='12'
                    md='12'
                    sm='12'
                    xs='12'
                    className='mb-1'
                    key={uuidv4()}
                  >
                    <Card>
                      <Card.Body
                        className='d-flex p-2'
                        style={{
                          backgroundColor: item?.isPRMAction
                            ? 'rgb(8, 144, 201)'
                            : 'inherit',
                          color: item?.isPRMAction ? 'white' : 'inherit',
                        }}
                      >
                        <Row className='w-100'>
                          <Col lg='1' xs='6'>
                            <span>{item?.isPRMAction ? 'PRM' : 'CRM'}</span>
                          </Col>
                          <Col lg='3' xs='6'>
                            <span>{item?.creatorName}</span>
                          </Col>
                          <Col lg='3' xs='6'>
                            <span>
                              {item?.persianCreateDate?.replaceAll(' ', '\n')}
                            </span>
                          </Col>
                          <Col lg='4' xs='6'>
                            <span>{item?.title}</span>
                          </Col>
                          <Col lg='1' xs='6'>
                            <Tooltip title={item?.description}>
                              {item?.description ? (
                                <span style={{ cursor: 'pointer' }}>شرح</span>
                              ) : (
                                '-'
                              )}
                            </Tooltip>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              : null}
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer className='pl-2 pr-3'>
        <Row className='my-3 d-flex justify-content-between w-100'>
          <Col lg={12} xs={12} className='d-flex align-items-baseline'>
            <Pagination
              totalPage={dataFetch.totalPage}
              page={dataFetch.page}
              handelprevpage={handlePrevPage}
              handelNextpage={handleNextPage}
              handelpagenumber={handlePageNumber}
            />
            <div className='d-flex ml-auto mr-sm-auto '>
              <p>مجموع کل: </p>
              <span className='mr-2'> {dataFetch.totalRecord} </span>
            </div>
            <div className='rowminger'>
              <p className='text-nowrap'>تعداد:</p>
              <Form.Control size='sm' as='select' onChange={handleRow}>
                {arrayOfPageSizes.map((item) => (
                  <option
                    key={item}
                    defaultValue={item === pageSize ? true : false}
                    value={item}
                  >
                    {item}
                  </option>
                ))}
              </Form.Control>
            </div>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalOrderTracking;
